




































































































































































































































import { Watch, Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import AddDocumentButton from '@/components/Admin/Layout/AddDocumentButton.vue';
import AddContractButton from '@/components/Admin/Layout/AddContractButton.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import AddDocumentForm from '@/components/Admin/Forms/AddDocumentForm.vue';
import EditDocumentForm from '@/components/Admin/Forms/EditDocumentForm.vue';
import AddContractForm from '@/components/Admin/Forms/AddContractForm.vue';
import EditContractForm from '@/components/Admin/Forms/EditContractForm.vue';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import PreviewMedia from '@/components/Admin/Panels/PreviewMedia.vue';
import cloneDeep from 'lodash/cloneDeep';
import DocumentsData from '@/ts/DocumentsData';
import Multiselect from 'vue-multiselect';
import RecipientMethods from '@/mixins/RecipientMethods.vue';
import Recipients from '@/components/Admin/Panels/Recipients.vue';

@Component({
    components: {
        SelectedItems,
        AddDocumentButton,
        AddContractButton,
        AddDocumentForm,
        EditDocumentForm,
        AddContractForm,
        EditContractForm,
        PreviewMedia,
        ConfirmPopup,
        Multiselect,
        Recipients,
    },
    computed: {
        ...mapGetters({
            previewMediaVisible: 'Documents/getPreviewMediaVisible',
            formVisible: 'Viewport/isAddFormVisible',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})
export default class Documents extends Mixins(DateMethods, RecipientMethods) {
    public documentCollapse: number = -1;
    public documentDropdown: boolean = false;
    public documentDropdownIndex: number = -1;
    public documents: any = [];
    public documentProjects: any = [];
    public sortableColumns: any[] = [
        {
            id: 0,
            title : 'Created',
            key : 'created_at',
            dir : 'asc',
            icon : 'down',
        },
        {
            id: 1,
            title : 'Last Update',
            key : 'updated_at',
            dir : 'desc',
            icon : 'up',
        },
    ];

    constructor() {
        super();
    }

    get projects() {
        return this.$store.getters['Projects/allProjects'];
    }

    get adminDocuments() {
        return this.$store.getters['Documents/getAdminDocuments'];
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get activeCategory() {
        return this.$store.getters['Categories/getActiveCategory'];
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    get categories(): any {
        const categories = this.$store.getters['Categories/getDocumentCategories'];

        return categories.map((category: any, index: number) => {
            const targetedTranslation = category.translations.find((translation: any) => translation.language.key === this.getLocalizationKey);
            return targetedTranslation ? {id: category.id, title: targetedTranslation.title} : {};
        });
    }

    get getLocalizationKey() {
        return this.$store.getters['Localization/getLocalizationKey'];
    }

    get allLanguages() {
        return this.$store.getters['Localization/getAllLanguages'];
    }

    get selectorsHasApplied() {
        const selectedBuildings  = this.$store.getters['Buildings/selectedBuildings'];
        const selectedProjects   = this.$store.getters['Projects/selectedProjects'];
        const selectedProperties = this.$store.getters['Projects/selectedProperties'];

        return (selectedBuildings && selectedBuildings.length) || (selectedProjects && selectedProjects.length) || (selectedProperties && selectedProperties.length);
    }

    public getLastUpdate(createdAt: string, updatedAt: string) {
        return createdAt === updatedAt ? 'Never Updated' : this.handleFormatedDate(updatedAt, 'YYYY-MM-DD hh:mm');
    }

    public previewMedia(id: number) {
        this.$store.dispatch(Actions.FETCH_DOCUMENT_MEDIA_PREVIEW, id);
    }

    public showCollapse(documentId: any) {
        if (documentId === this.documentCollapse) {
            this.documentCollapse = -1;
            return;
        }

        this.documentCollapse = documentId;
    }

    @Watch('adminDocuments')
    public adminDocumentsChanged() {
        if (this.activeCategory !== null) {
            this.documents = cloneDeep(this.adminDocuments).filter((document: DocumentsData) => {
                return document.categories.includes(this.activeCategory.id);
            });
        } else {
            this.documents = cloneDeep(this.adminDocuments);
        }
    }

    @Watch('getLocalizationKey')
    public getLocalizationKeyChanged() {
        if (this.activeCategory !== null) {
            this.$store.commit(Mutations.SET_ACTIVE_CATEGORY, this.categories.find((category: any) => category.id === this.activeCategory.id ));
        }
    }

    @Watch('documentProjects')
    public getDocumentProjectsChanged() {
        this.$store.commit(Mutations.SET_DOCUMENT_PROJECT_OPTION, this.documentProjects);

        this.$store.dispatch(Actions.FETCH_ADMIN_DOCUMENTS, {
            dir: this.$store.getters['Documents/getDocumentDirOption'],
            column: this.$store.getters['Documents/getDocumentColumnOption'],
            search: this.$store.getters['Documents/getDocumentSearchOption'],
            project: this.documentProjects,
        });
    }

    public getDocumentLocalizedTitle(translations: any) {
        const targetedTranslation =  translations.find((translation: any) => translation.language.key === this.getLocalizationKey);

        return typeof targetedTranslation !== 'undefined'
            ? targetedTranslation.title
            : translations[0].title;
    }

    public toggleValue(current: any, first: any, second: any) {
        return current === first ? second : first;
    }

    public toggleDocumentDropdown(index: number) {
        if (index === this.documentDropdownIndex) {
            this.closeDropDown();
        } else {
            this.documentDropdown = this.documentDropdownIndex !== -1 ? true : !this.documentDropdown;
            this.documentDropdownIndex = index;
        }
    }

    public closeDropDown() {
        this.documentDropdown = false;
        this.documentDropdownIndex = -1;
    }

    public resetSort(id: number) {
        this.sortableColumns.forEach((column: any) => {
            if (id !== column.id) {
                column.icon = 'down';
                column.dir = 'asc';
            }
        });
    }

    public sortDocumentsBy(id: number) {
        this.resetSort(id);

        const sortableColumn = this.sortableColumns[id];
        sortableColumn.icon = this.toggleValue(sortableColumn.icon, 'up', 'down');
        sortableColumn.dir = this.toggleValue(sortableColumn.dir, 'asc', 'desc');
        const dir = sortableColumn.dir;
        const column = sortableColumn.key;

        this.$store.commit(Mutations.SET_DOCUMENT_COLUMN_OPTION, column);
        this.$store.commit(Mutations.SET_DOCUMENT_DIR_OPTION, dir);
        this.$store.dispatch(Actions.FETCH_ADMIN_DOCUMENTS, {
            dir,
            column,
            search: this.$store.getters['Documents/getDocumentSearchOption'],
            project: this.documentProjects,
        });
    }

    public setDocumentSerachOption(ev: any) {
        this.$store.commit(Mutations.SET_DOCUMENT_SEARCH_OPTION, ev.srcElement.value);
        this.$store.dispatch(Actions.FETCH_ADMIN_DOCUMENTS, {
            dir: this.$store.getters['Documents/getDocumentDirOption'],
            column: this.$store.getters['Documents/getDocumentColumnOption'],
            search: ev.srcElement.value,
            project: this.documentProjects,
        });
    }

    public addDocument(withCategory: false) {
        if (withCategory) {
            this.$store.commit(Mutations.SET_CREATE_DOCUMENT_WITH_CATEGORY, withCategory);
        }

        this.$store.dispatch(Actions.SHOW_FORM, 'add-document');
    }

    public addContract() {
        this.$store.dispatch(Actions.SHOW_FORM, 'add-contract');
    }

    public updateDocument(id: number) {
        this.closeDropDown();

        this.$store.dispatch(Actions.FETCH_CURRENT_DOCUMENT, { id, action: 'update' });
    }

    public deleteDocument(id: number, title: string) {
        this.closeDropDown();

        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Documents/DELETE_DOCUMENT',
            confirmActionData: { id },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-document', 'Are you sure you want to delete this document?'),
            confirmInfoText: `${title}`,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public setActiveCategory(category: any) {
        if (this.activeCategory && this.activeCategory.id === category.id) {
            this.$store.commit(Mutations.SET_ACTIVE_CATEGORY, null);
            this.documents = cloneDeep(this.adminDocuments);
        } else {
            this.$store.commit(Mutations.SET_ACTIVE_CATEGORY, category);

            this.documents = cloneDeep(this.adminDocuments).filter((document: DocumentsData) => {
                return document.categories.includes(category.id);
            });
        }
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);

        this.$store.dispatch(Actions.FETCH_ADMIN_DOCUMENTS, {
            dir: 'desc',
            column: 'id',
            search: '',
            project: this.documentProjects,
        });

        this.$store.commit(Mutations.SET_DOCUMENT_COLUMN_OPTION, 'id');
        this.$store.commit(Mutations.SET_DOCUMENT_DIR_OPTION, 'desc');
        this.$store.commit(Mutations.SET_DOCUMENT_SEARCH_OPTION, '');
        this.$store.dispatch(Actions.FETCH_DOCUMENT_CATEGORIES);
        this.$store.dispatch(Actions.FETCH_PROPERTIES);
    }

    public mounted() {
        if (typeof this.$route.params.documentId !== 'undefined') {
            this.updateDocument(Number(this.$route.params.documentId));
        }
    }
}
